export default "__VITE_ASSET__CGN6C4Dm__"